const crypto = require('crypto')

const createFileChecksum = file => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		let checksum = null

		reader.onerror = reject
		reader.onload = async () => {
			const binaryStr = reader.result
			const fileBuffer = Buffer.from(new Uint8Array(binaryStr))
			checksum = crypto.createHash('MD5').update(fileBuffer).digest('hex')

			if (checksum) {
				resolve(checksum)
			}
			else {
				resolve(false)
			}
		}

		reader.readAsArrayBuffer(file)
	})
}


export default createFileChecksum